import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Injectable, inject, DOCUMENT, computed, DestroyRef } from "@angular/core";
import { NavigationStart, NavigationEnd, Router } from "@angular/router";
import { IRoutingSyncMessageType, isRoutingSyncEventFromParent, sendRoutingSyncToParent } from "./routing-sync-util";
import { fromEvent } from "rxjs";
import { filter } from "rxjs/operators";

/* istanbul ignore next */
@Injectable({
    providedIn: "root",
})
export class RoutingParentSyncService {
    private readonly destroyRef = inject(DestroyRef);
    private document = inject<Document>(DOCUMENT);
    private router = inject(Router);

    parentUrl!: URL;

    public readonly currentUrlPath = computed(() => {
        const nav = this.router.lastSuccessfulNavigation();
        return nav?.finalUrl?.toString() || this.router.url;
    });

    constructor() {
        this.init();
    }

    private init(): void {
        if (window !== top) {
            this.parentUrl = new URL(this.document.referrer ? this.document.referrer : this.document.location.ancestorOrigins[0]);
            this.router.events
                .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe((event) => {
                    sendRoutingSyncToParent(window.parent, this.parentUrl.origin, event.urlAfterRedirects);
                });

            this.router.events
                .pipe(filter((event): event is NavigationStart => event instanceof NavigationStart))
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe((event) => {
                    if (event.navigationTrigger === "popstate" && event.restoredState?.navigationId === -1) {
                        this.router.navigate([this.router.routerState?.snapshot?.url]);
                    }
                });

            fromEvent(window, "message")
                .pipe(
                    filter((event): event is IRoutingSyncMessageType =>
                        isRoutingSyncEventFromParent(this.parentUrl.origin, event as MessageEvent<unknown>),
                    ),
                )
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe((event) => {
                    this.router.navigateByUrl(event.data.url, {
                        skipLocationChange: true,
                    });
                });
        }
    }
}
